<template>
  <div class="collapse" :class="classes" :style="style">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "CollapseItem",
  props: {
    visible: { type: Boolean, default: false },
  },
  data: () => {
    return {
      isOpen: false,
      toggleEl: null,
      style: null,
    };
  },
  computed: {
    classes() {
      let classes = [];
      if (this.isOpen) classes.push("show");
      return classes;
    },
  },
  watch: {
    visible(n) {
      if (n) this.open();
      else this.close();
    },
  },
  mounted() {
    this.isOpen = this.visible;

    this.toggleEl = document.body.querySelector(
      `[collapse-target="${this.$el.getAttribute("id")}"]`
    );
    if (this.toggleEl) {
      this.toggleEl.addEventListener("click", this.toggle);
      if (!this.isOpen) {
        this.toggleEl.classList.add("collapsed");
      }
    }
  },
  beforeUnmount() {
    if (this.toggleEl) {
      this.toggleEl.removeEventListener("click", this.toggle);
    }
  },
  methods: {
    async getHeight() {
      const cacheStyle = { ...this.style };
      this.style = { height: "auto" };
      await this.$nextTick();
      const height = this.$el.offsetHeight;
      this.style = { ...cacheStyle };
      return height;
    },
    toggle() {
      if (this.isOpen) this.close();
      else this.open();
    },
    async open() {
      if (this.toggleEl) this.toggleEl.classList.remove("collapsed");

      const height = await this.getHeight();
      this.collapsedOther();

      this.style = { height: 0 };
      await new Promise((resolve) => setTimeout(resolve, 0));
      this.style = { height: `${height}px` };
      await new Promise((resolve) => setTimeout(resolve, 300));
      this.isOpen = true;
      this.style = null;
    },
    async close() {
      if (this.toggleEl) this.toggleEl.classList.add("collapsed");

      const height = await this.getHeight();

      this.style = { height: `${height}px` };
      this.isOpen = false;
      await new Promise((resolve) => setTimeout(resolve, 0));
      this.style = { height: 0 };
      await new Promise((resolve) => setTimeout(resolve, 300));
      this.style = null;
    },
    collapsedOther() {
      const accordion = this.$el.getAttribute("accordion");
      if (!accordion) return null;
      document.body
        .querySelectorAll(`.collapse.show[accordion="${accordion}"]`)
        .forEach((element) => {
          const toggleEl = document.body.querySelector(
            `[collapse-target="${element.getAttribute("id")}"]`
          );
          toggleEl.dispatchEvent(new Event("click"));
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.collapse {
  height: 0;
  overflow: hidden;
  transition: all 0.3s ease;

  &.show {
    height: auto;
  }
}
</style>
